export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "opfs-polyfill.worker.640eade510a8aceeabe3.worker.js");
}
